import * as React from 'react'
import {
  useShowContext,
  SimpleShowLayout,
  Show,
  useTranslate,
} from 'react-admin'
import { Grid, Typography, Container, List, ListItem, ListItemText, Divider } from '@mui/material'
import { CardCommon } from 'src/components/uiElements/cards/CardCommon'


const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ListElement = (props) => {
  return (
    <>
      <ListItem disableGutters>
        <ListItemText
          primary={
            <>
              {' '}
              <Typography
                sx={{ display: 'inline-block', minWidth: 120 }}
                component='span'
                variant='body2'
                color='text.primary'
              >
                {props.label}{' '}
              </Typography>
              <Typography
                sx={{ display: 'inline-block', minWidth: 120 }}
                component='p'
                variant='body2'
                color='text.primary'
              >
                {props.value}{' '}
              </Typography>
            </>
          }
        />
      </ListItem>
      <Divider variant='fullWidht' component='li' />
    </>
  )
}

const ShowContent = () => {
  const translate = useTranslate()
  const {
    defaultTitle, // the translated title based on the resource, e.g. 'Post #123'
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isFetching, // boolean that is true while the record is being fetched, and false once the record is fetched
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
    refetch, // callback to refetch the record via dataProvider.getOne()
    resource, // the resource name, deduced from the location. e.g. 'posts'
  } = useShowContext()

  if (isLoading) {
    return <div>{translate('ra.action.loading')}</div>
  }
  if (error) {
    return <div>{translate('ra.notification.http_error')}</div>
  }

  return (
    <>
      <Typography variant='h3' component='h1' sx={{ marginBottom: 2 }}>
        {defaultTitle}
      </Typography>
      <SimpleShowLayout sx={{ p: 0 }}>
        <CardCommon title={'General'} actions={''}>
          <Grid container spacing={2} /* sx={{ margin: 2 }} */>
            <Grid item xs={12} sm={9}>
              <List sx={{ width: '100%' /* maxWidth: 360, bgcolor: 'background.paper'  */ }}>
                <ListElement label={'ID'} value={record.id} />
                <ListElement label={'hotel name'} value={record.hotel_name} />
                <ListElement label={translate('ra.field.date_in')} value={record.date_in} />
                <ListElement label={translate('ra.field.date_out')} value={record.date_out} />
              </List>
            </Grid>
          </Grid>
        </CardCommon>
      </SimpleShowLayout>
    </>
  )
}

export const HotelDetailShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props}>
      <ShowContent {...props} />
    </Show>
  )
}
